module.exports = __webpack_public_path__ + "static/img/news-cover.0db2300.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/news-cover.jpg
// module id = h4PF
// module chunks = 0